exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".transition-fade-enter-active,.transition-fade-leave-active{transition:opacity .3s}.transition-fade-enter,.transition-fade-leave-to{opacity:0}.transition-fade-enter-to,.transition-fade-leave{opacity:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-412c5438","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/transition/Fade.vue
// module id = 60207a6f2c03cefe8711
// module chunks = 0